module.exports = __webpack_public_path__ + "static/media/proa_roraima_114.4f0a9518.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/proa_roraima_114.jpg
// module id = 125
// module chunks = 0